import { Tooltip, getTestAttributes, slug, noop } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import CheckboxField from '../../../../../../primitives/form/CheckboxField/CheckboxField';

const FormTemplateTrialContainerCard = forwardRef((props, ref) => {
  const { name, active = true, disabled = false, titleClass = '', id = null, onSelectTrialContainer = noop } = props;

  return (
    <div
      ref={ref}
      className={`form-template-trial-container-card ${active ? 'form-template-trial-container-card__active' : ''}`}
      {...getTestAttributes('form-template-trial-container')}
    >
      <span
        className={`form-template-trial-container-card__name ${titleClass}`}
        {...getTestAttributes('form-template-trial-container-name')}
      >
        {name}
      </span>
      <Tooltip content={disabled ? 'Required Form Template in use in this Site' : null} id={`tooltip-${id}`}>
        <div className="form-template-trial-container-card__checkbox">
          <div className="form__group">
            <CheckboxField
              showError={false}
              errorMessage=""
              fieldID={`trial-container-${id}`}
              fieldIdentifier={`${slug(name)}-checkbox`}
              optionText=""
              fieldRequired={false}
              optionValue=""
              handleChange={() => {
                onSelectTrialContainer(id);
              }}
              disabled={disabled}
              checked={active}
            />
          </div>
        </div>
      </Tooltip>
    </div>
  );
});

FormTemplateTrialContainerCard.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.number,
  name: PropTypes.string.isRequired,
  titleClass: PropTypes.string,
  onSelectTrialContainer: PropTypes.func,
};

export default FormTemplateTrialContainerCard;
